import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { AccountCircle } from '@mui/icons-material';
import Lock from '@mui/icons-material/Lock';
import { IconButton, InputAdornment } from '@mui/material';
import { useDispatch } from 'react-redux';
import { ErrorMessage } from 'Constants/Database';
import { VALID_PAYROLL_NUMBER } from 'Constants/Regex';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { GooglePlay, AppleStore, LoginImage, LogoKappaBlack } from 'Images/index';
import PasswordEye from 'Pages/AssignPassword/Components/PasswordEye';
import useTranslation from '../../Hooks/useTranslation';
import useInput from '../../Hooks/useInput';
import CustomLabel from '../../Utils/CustomLabel';
import Styles from './styles';
import { fetchUser } from '../../Redux/LoggedUserSlice';

export default function index() {
  document.body.style.overflow = 'hidden';
  const { t2 } = useTranslation('Login');
  const dispatch = useDispatch();
  const textFieldStyles = Styles.textFieldStyles();
  const payrollNum = useInput('');
  const password = useInput('');
  const [showPassword, setShowPassword] = useState(false);
  const getColoredWord = () => (
    <span key={t2('AppSugestionIncrease')} style={{ color: '#00984A', fontWeight: 'bold' }}>
      {t2('AppSugestionIncrease')}
    </span>
  );

  const messageError = (pass, pay) => {
    password.setErrorMessage(pass);
    payrollNum.setErrorMessage(pay);
  };

  const statusError = (pass, pay) => {
    password.setError(pass);
    payrollNum.setError(pay);
  };

  const clearErrors = () => {
    password.setError(false);
    payrollNum.setError(false);
    password.setErrorMessage('');
    payrollNum.setErrorMessage('');
  };

  /**
   * Muestra un mensaje de error en el campo de contraseña o número de empleado
   * @param {string} passwordMessage Mensaje de error de contraseña
   * @param {string} employeeNumberMessage Mensaje de error de número de empleado
   */
  const displayError = ({ passwordMessage, employeeNumberMessage }) => {
    // Limpiamos los mensajes de error antes de continuar.
    clearErrors();

    // Mostramos el mensaje de error en el campo de contraseña
    if (passwordMessage) {
      password.setErrorMessage(passwordMessage);
      password.setError(true);
    }

    // Mostramos el mensaje de error en el campo de número de empleado
    if (employeeNumberMessage) {
      payrollNum.setErrorMessage(employeeNumberMessage);
      payrollNum.setError(true);
    }
  };

  const loginAPI = async () => {
    dispatch(
      fetchUser({
        payrollNum: payrollNum.value,
        password: password.value,
        catchError: errorMessage => {
          if (errorMessage === ErrorMessage.incorrectPassword) {
            displayError({
              passwordMessage: errorMessage,
            });
          } else {
            displayError({
              employeeNumberMessage: errorMessage,
            });
          }
        },

        clearError: () => {
          statusError(false, false);
          messageError('', '');
        },
      })
    );
  };

  const validate = async () => {
    const validPayrollNum = new RegExp(VALID_PAYROLL_NUMBER);

    if (payrollNum.value === '') {
      payrollNum.setError(true);
      payrollNum.setErrorMessage(t2('MissingPayrollNum'));

      if (password.value === '') {
        password.setError(true);
        password.setErrorMessage(t2('MissingPassword'));
      }

      return;
    }

    if (!validPayrollNum.test(payrollNum.value)) {
      messageError('', t2('IncorrectPayrollNum'));
      statusError(false, true);
      return;
    }

    loginAPI();
  };

  return (
    <div style={Styles.loginContainer} className="flex">
      <div style={Styles.formContainer} className="flex col">
        <div className="flex col">
          <CustomLabel type="h1" value={t2('LoginWelcome')} font="Quicksand" />
          <CustomLabel type="p" value={t2('EnterCredentialsCaption')} />
        </div>
        <div className="flex col">
          <TextField
            label={t2('EmployeeNumber')}
            placeholder={t2('EmployeeNumberPlaceholder')}
            style={Styles.emailInput}
            classes={{ root: textFieldStyles.root }}
            color="MexlogGreen"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
            {...payrollNum.bind}
          />

          <TextField
            label={t2('PasswordCaption')}
            placeholder="********"
            type={showPassword ? 'text' : 'password'}
            color="MexlogGreen"
            classes={{ root: textFieldStyles.root }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Lock />
                </InputAdornment>
              ),
              endAdornment: <PasswordEye visibility={showPassword} onClick={() => setShowPassword(!showPassword)} />,
            }}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                validate();
              }
            }}
            {...password.bind}
          />
        </div>

        <Button onClick={validate} style={Styles.loginButton}>
          {t2('LoginButton')}
        </Button>
        <hr
          style={{
            width: '100%',
            backgroundColor: 'rgba(210, 210, 210, 0.57)',
            height: '1px',
            border: '0px',
          }}
        />
        <div>
          <CustomLabel type="p" value={t2('AppSugestion', [getColoredWord()])} style={Styles.appDownloadCaption} />
          <div style={{ justifyContent: 'center' }} className="flex">
            <img src={GooglePlay} alt="" style={Styles.appDownloadImage} />
            <img src={AppleStore} alt="" style={Styles.appDownloadImage} />
          </div>
        </div>
      </div>

      <div style={Styles.coverImageContainer} className="flex">
        <img
          src={LogoKappaBlack}
          alt=""
          style={{
            position: 'absolute',
            alignSelf: 'flex-end',
            paddingTop: '1%',
            paddingRight: '1%',
            width: '25%',
          }}
          className="flex"
        />
        <img src={LoginImage} alt="" style={Styles.coverImage} />
      </div>
    </div>
  );
}
